import React from 'react';
import { useNavigate } from 'react-router-dom';
import DispatchBoardView from './DispatchBoardView';
import DriversView from './DriversView';

// UX pass 2026-10-25. Val: "Dispatch Board should be renamed 'Dispatcher'" and "Affiliates should disappear into
// Dispatcher". One menu item, one page, two sections: the board (queue, history, payable staff, escalations) and the
// affiliate roster. The addresses stay the same (/dispatch and /dispatch/affiliates), so bookmarks and links keep
// working, and both sections keep the same Dispatch "view" permission check they had as separate pages.
export const DISPATCHER_SECTIONS = Object.freeze([
    { id: 'board', label: 'Board', path: '/dispatch' },
    { id: 'group-transfers', label: 'Group Transfers', path: '/dispatch/group-transfers' },
    { id: 'affiliates', label: 'Affiliates', path: '/dispatch/affiliates' },
]);

const TAB = 'ia-hover-pulse inline-flex min-h-[44px] items-center rounded-full border px-4 text-sm font-medium';

export default function DispatcherView({ section = 'board', userId, theme = 'light', isUser = false }) {
    const navigate = useNavigate();
    const active = DISPATCHER_SECTIONS.some((item) => item.id === section) ? section : 'board';
    return (
        <div className="ia-dispatcher h-full flex flex-col" data-testid="dispatcher">
            <div className="mb-3">
                <h1 className="text-2xl font-bold text-[var(--ink)]">🚐 Dispatcher</h1>
                <p className="text-sm text-[var(--ink-muted)]">Assign trips, follow every assignment, and work with your affiliates.</p>
            </div>
            <div role="tablist" aria-label="Dispatcher sections" className="mb-4 flex flex-wrap gap-2">
                {DISPATCHER_SECTIONS.map((item) => {
                    const selected = item.id === active;
                    return (
                        <button key={item.id} type="button" role="tab" id={`dispatcher-tab-${item.id}`}
                            aria-selected={selected} aria-controls="dispatcher-panel" tabIndex={selected ? 0 : -1}
                            onClick={() => { if (!selected) navigate(item.path); }}
                            onKeyDown={(event) => {
                                if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
                                const index = DISPATCHER_SECTIONS.findIndex((entry) => entry.id === active);
                                const next = DISPATCHER_SECTIONS[(index + (event.key === 'ArrowRight' ? 1 : -1) + DISPATCHER_SECTIONS.length) % DISPATCHER_SECTIONS.length];
                                navigate(next.path);
                            }}
                            className={`${TAB} ${selected
                                ? 'ia-selected-pill border-[var(--selected-pill-border)] text-[var(--selected-pill-ink)]'
                                : 'border-[var(--ui-border)] text-[var(--ink-muted)]'}`}>
                            {item.label}
                        </button>
                    );
                })}
            </div>
            <div id="dispatcher-panel" role="tabpanel" aria-labelledby={`dispatcher-tab-${active}`} className="min-h-0 flex-1">
                {active === 'affiliates'
                    ? <DriversView userId={userId} theme={theme} isUser={isUser} embedded />
                    : <DispatchBoardView userId={userId} theme={theme} isUser={isUser} embedded />}
            </div>
        </div>
    );
}
